import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/SESSIONS';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    (sessionId, includePricesForAllPricingGroups) => ({sessionId, includePricesForAllPricingGroups}),
    sessions => ({sessions}),
    error => ({error}),
);

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(
    `${domain}/FETCH_ALL`,
    (
        institutionId,
        validOn,
        validTo,
        ageGroupId,
        includeDiscontinued,
        filterCurrent,
        includePricesForAllPricingGroups,
    ) => ({
        institutionId,
        validOn,
        validTo,
        ageGroupId,
        includeDiscontinued,
        filterCurrent,
        includePricesForAllPricingGroups,
    }),
    (sessions, behaviors, filterCurrent) => ({sessions, behaviors, filterCurrent}),
    error => ({error}),
);

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(
    `${domain}/CREATE`,
    session => ({session}),
    (session, institutionId) => ({session, institutionId}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
    aborted: updateAborted,
} = createAction(
    `${domain}/UPDATE`,
    (session, newVersion) => ({session, newVersion}),
    (oldSession, newSession, institutionId) => ({oldSession, newSession, institutionId}),
    session => ({session}),
    session => ({session}),
);

export const {
    action: remove,
    success: removeSuccess,
    failed: removeFailed,
    aborted: removeAborted,
} = createAction(
    `${domain}/REMOVE`,
    session => ({session}),
    (session, institutionId) => ({session, institutionId}),
    session => ({session}),
    session => ({session}),
);

export const {
    action: restore,
    success: restoreSuccess,
    failed: restoreFailed,
    aborted: restoreAborted,
} = createAction(
    `${domain}/RESTORE`,
    session => ({session}),
    (session, institutionId) => ({session, institutionId}),
    session => ({session}),
    session => ({session}),
);

export const {
    action: unschedule,
    success: unscheduleSuccess,
    failed: unscheduleFailed,
    aborted: unscheduleAborted,
} = createAction(
    `${domain}/UNSCHEDULE`,
    (session, last) => ({session, last}),
    (unscheduledSessionVersionId, last, remainingVersions) => ({unscheduledSessionVersionId, last, remainingVersions}),
    session => ({session}),
    session => ({session}),
);
